// https://github.com/vercel/next.js/discussions/11209#discussioncomment-38480
// Hack needed to avoid JSON-Serialization validation error from Next.js https://github.com/zeit/next.js/discussions/11209
// >>> Reason: `undefined` cannot be serialized as JSON. Please use `null` or omit this value all together.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteUndefined = <T>(obj: T | object | undefined): T => {
  if (obj) {
    Object.keys(obj).forEach((key: string) => {
      if (obj[key] && typeof obj[key] === 'object') {
        deleteUndefined(obj[key]);
      } else if (typeof obj[key] === 'undefined') {
        obj[key] = null; // eslint-disable-line no-param-reassign
      }
    });
  }

	return obj as T;
};

export const prepareNextJsProps = <T>(props: T): T => deleteUndefined(props);
